import { t } from '@lingui/core/macro';
import { MetadataAllowedValuesFilter } from './MetadataAllowedValuesFilter';
export const documentTypeFilterLabel = () => t({ message: 'Document type', comment: 'Insights filter: Document type' });
export function DocumentTypeFilter() {
    return (<MetadataAllowedValuesFilter name="DocumentType" field="metadataDocumentDocumentType" label={documentTypeFilterLabel()}/>);
}
